import {EmailReportTemplateEnum} from "./email-report-template.enum";
import {RecurringType} from "../../commons/types/recurring.type";

export const EmailReportRecurringEnum = {
  [EmailReportTemplateEnum.DailyGroupsWorkloadReport]: [RecurringType.DAILY, RecurringType.WEEKLY],
  [EmailReportTemplateEnum.DailyBranchesWorkloadReport]: [RecurringType.DAILY, RecurringType.WEEKLY],
  [EmailReportTemplateEnum.DailyAgentWorkloadReport]: [RecurringType.DAILY, RecurringType.WEEKLY],
  [EmailReportTemplateEnum.InactiveAgentReport]: [RecurringType.DAILY, RecurringType.WEEKLY],
  [EmailReportTemplateEnum.TeamsAgentWorkloadReport]: [RecurringType.DAILY, RecurringType.WEEKLY],
  [EmailReportTemplateEnum.TeamsWorkloadReport]: [RecurringType.DAILY, RecurringType.WEEKLY],
  [EmailReportTemplateEnum.RoutePlanningStatus]: [RecurringType.DAILY],
}
